module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_34-3a67d2c5bf6f6b302e6c91aa54cf2585.png";